import React from "react";
import { useAppText } from "src/commun/composants/AppText";
import { useFormikContext } from "formik";
import AppRow from "src/commun/composants/grille/AppRow";
import { VerificationTelephone } from "src/pages/finalisation/etapes/verificationTelephone/codeTelephoneSend/useValidationSchemaTelephone";
import TelephoneField from "src/commun/composants/formulaire/fields/TelephoneField";


export type CodeTelephoneSendFormContentProps = {
  pageSuivante?: (data: any) => void;
  canSkip?: boolean;
  displayCancelBtn?: boolean;
  cancelCallback?: () => void;
};

const CodeTelephoneSendFormContent = ({ pageSuivante, canSkip, displayCancelBtn, cancelCallback }: CodeTelephoneSendFormContentProps) => {
  const { tString } = useAppText();
  const { submitForm } = useFormikContext<VerificationTelephone>();

  return (
    <>
      <div className="input">
        <TelephoneField name="mobileNumber" />
      </div>
      <AppRow>
        {canSkip &&
          <input
            className="btn__primary mt-3 mr-3 btn--full--xs"
            type="submit"
            name="submit"
            onClick={pageSuivante}
            value={tString("compte.mon.profile.mobile.saisi.non.souhaite")}
          />
        }
        {displayCancelBtn &&
          <input
            className="btn__primary mt-3 mr-3 btn--full--xs"
            type="submit"
            name="annuler"
            onClick={cancelCallback}
            value={tString("update.mobile.cancel.button")}
          />
        }
        <input
          className="btn__primary mt-3 btn--full--xs"
          type="submit"
          name="submit"
          onClick={submitForm}
          value={tString("action.recevoir.code.validation")}
        />
      </AppRow>
    </>
  );
};

export default CodeTelephoneSendFormContent;